import { useContext } from "react";
import { BlueprintGenerationTasksContext } from "components/Blueprints";

/**
 * useBlueprintGenerationTasksContext - Hook to access the blueprints being read and polled for generation
 * Throws error if used outside provider
 */
export default function useBlueprintGenerationTasksContext() {
  const context = useContext(BlueprintGenerationTasksContext);

  if (!context) {
    throw new Error("useBlueprintGenerationTasksContext must be used within BlueprintGenerationTasksProvider");
  }

  return context;
}
